import { ChatMessage, SeenEntry } from "./ChatMessage";
import { FileMessage } from "./FileMessage";

export interface FileData {
  fileName: string;
  fileType: string;
  fileSize: number;
  fileHash: string;
  fileLocation: string;
  fileTitle: string;
  transferId: string;
  creationDate: string;
  modificationDate: string;
  direction: string;
}

export class Message extends ChatMessage {
  text: string;
  repliedTo: Message | FileMessage | null;
  messageType?: "text" | "file-transfer";
  fileData?: FileData;
  pageNumber?: number;
  totalPageNumber?: number;

  constructor(
    text: string,
    messageId: string,
    isOwner: boolean,
    chatRoomId: string,
    senderName: string,
    repliedTo: Message | FileMessage | null,
    sentTime: Date | null,
    deliveredTime: Date | null,
    seenTimes: SeenEntry[],
    editedTime: Date | null,
    deletedTime: Date | null,
    arrivalTime: Date| null,
    messageType?: "text" | "file-transfer",
    fileData?: FileData,
    pageNumber?: number,
    totalPageNumber?: number
  ) {
    super(messageId, isOwner, chatRoomId, senderName, sentTime, deliveredTime, seenTimes, editedTime, deletedTime, arrivalTime);
    this.text = text;
    this.repliedTo = repliedTo;
    this.messageType = messageType || "text";
    this.fileData = fileData;
    this.pageNumber = pageNumber;
    this.totalPageNumber = totalPageNumber;
  }

  toMap(): { [key: string]: any } {
    return {
      ...super.toMap(),
      text: this.text,
      repliedTo: this.repliedTo,
      messageType: this.messageType,
      fileData: this.fileData,
      pageNumber: this.pageNumber,  
      totalPageNumber: this.totalPageNumber
    };
  }

  static fromMap(map: { [key: string]: any }): Message {
    const isOwner = map["isOwner"] === 1 || map["isOwner"] === true || map["isOwner"] === "1";

    let seenTimes: SeenEntry[] = [];
    if (map["seenTimes"] !== undefined && map["seenTimes"] !== null) {
      if (typeof map["seenTimes"] === 'string') {
        try {
          if (map["seenTimes"] === '' || map["seenTimes"] === '[]') {
            seenTimes = [];
          } else {
            const parsedSeenTimes = JSON.parse(map["seenTimes"]);
            if (Array.isArray(parsedSeenTimes)) {
              seenTimes = parsedSeenTimes.map((entry: any) => ({
                name: entry.name,
                time: new Date(entry.time)
              }));
            } else {
              console.warn("Parsed seenTimes is not an array:", parsedSeenTimes);
              seenTimes = [];
            }
          }
        } catch (error) {
          console.warn("Failed to parse seenTimes string:", map["seenTimes"], error);
          seenTimes = [];
        }
      } else if (Array.isArray(map["seenTimes"])) {
        seenTimes = map["seenTimes"].map((entry: any) => ({
          name: entry.name,
          time: new Date(entry.time)
        }));
      } else {
        console.warn("seenTimes is neither string nor array:", typeof map["seenTimes"], map["seenTimes"]);
        seenTimes = [];
      }
    }

    return new Message(
      map["text"],
      map["messageId"],
      isOwner,
      map["chatRoomId"],
      map["senderName"],
      map["repliedTo"],
      map["sentTime"] ? new Date(map["sentTime"]) : null,
      map["deliveredTime"] ? new Date(map["deliveredTime"]) : null,
      seenTimes,
      map["editedTime"] ? new Date(map["editedTime"]) : null,
      map["deletedTime"] ? new Date(map["deletedTime"]) : null,
      map["messageType"] || "text",
      map["fileData"],
      map["pageNumber"],
      map["totalPageNumber"]
    );
  }
}